// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useMemo} from 'react';
import cn from 'classnames';
import {useStore} from '@nanostores/react';
import {$is_mobile} from '../../store/is_mobile.js';
import store from '../../store.js';
import {LINKS} from '../../utils/path.js';
import {sort_links_by_platform} from '../../utils/platform.js';
import {APP_TITLE} from '../../utils/constants.js';
import {Qr_code} from '../qr_code';
import {Text} from '../text';
import {Button} from '../button';
import * as cns from './downloads.module.less';

const cp = l=>l;

function Header({inline}){
    if (inline)
        return <Text.s bold className={cns.title_small}>Download for:</Text.s>;
    return <>
      <Text.xxxl h3>Platforms</Text.xxxl>
      <Text.s className={cns.brief}>
        Download {APP_TITLE} on different devices to maximize your earnings
      </Text.s>
    </>;
}

const get_tip = (data, url, is_mobile)=>{
    if (!data.qr_ok || is_mobile)
        return null;
    return <Qr_code url={url} size={128}/>;
};

export function Downloads({className, inline}){
    const is_mobile = useStore($is_mobile);
    const [full_meta] = store.use_downloads();
    const links = useMemo(()=>LINKS.map(cp).sort(sort_links_by_platform), []);
    return <div className={cn(cns.root, inline&&cns.root__inline, className)}>
      <Header inline={inline}/>
      <ul className={cns.list}>
        {links.map((link, i)=>{
            const meta = full_meta[link.id]||{};
            const l = Object.assign({}, link, meta);
            const ver = meta?.version;
            if (l.inactive||l.ver_required&&!ver)
                return null;
            const extra = {disabled: !!l.disabled};
            if (l.direct)
                extra.download = true;
            else
                extra.target = '_blank';
            const url = l.ref(ver);
            return <li key={l.id} className={cns.item}>
              <Button className={cns.link} href={url} ico={l.icon}
                size="l" hide_new_tab_ico tip={get_tip(link, url, is_mobile)}
                tip_placement="bottom" tip_show_delay_s={0.33} {...extra}>
                {i==0&&!inline ? `Download for ${l.title}` : ''}
              </Button>
            </li>;
        })}
      </ul>
    </div>;
}
